import type { MouseEvent } from 'react';
import type { NavigateFunction } from 'react-router-dom';

/**
 * Makes a whole table row clickable while staying well-behaved:
 * - clicks on links or buttons inside the row are left alone (they navigate
 *   themselves, and keep ctrl/cmd/middle-click "open in new tab" working)
 * - a click that's actually a text selection doesn't yank the user away
 *
 * Usage: <tr onClick={rowNav(navigate, `/orders/${id}`)} className="cursor-pointer">
 */
export function rowNav(navigate: NavigateFunction, to: string) {
  return (e: MouseEvent<HTMLElement>) => {
    if ((e.target as HTMLElement).closest('a, button')) return;
    if (window.getSelection()?.toString()) return;
    navigate(to);
  };
}
